import type { StyleSystemProps } from '@withjoy/joykit';
import { Flex, styled } from '@withjoy/joykit';

export const WrapperStyled = styled(Flex)``;

const wrapperStyles: StyleSystemProps = {
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',
  paddingX: 8,
  paddingTop: 3,
  paddingBottom: 6,
  marginTop: 4,
};

export const styles = {
  wrapper: wrapperStyles,
};
